import client from './client';

// Current org credit snapshot: { balance, held, available }
export const getCreditBalance = () => client.get('/api/credits/balance');

// Paged usage history (newest first)
export const getCreditHistory = (page = 0, size = 20) =>
  client.get(`/api/credits/history?page=${page}&size=${size}`);

// Active sellable packs
export const getCreditPacks = () => client.get('/api/credits/packs');

// Start a purchase. provider is optional (defaults to MANUAL server-side).
export const checkoutCredits = (packId, provider) =>
  client.post('/api/credits/checkout', { packId, provider });
